//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'TwitchPreFlightCheck',

    props: {
        link: {
            type: String,
            default: 'https://www.twitch.tv/leahinmoonlight',
        },
    },

    methods: {
        trackView() {
            this.$gtag.event('twitch-preflight-yes')
            this.$vuedals.close(this)
        },

        close() {
            this.$gtag.event('twitch-preflight-no')
            this.$vuedals.close(this)
        },
    },
}
